import React, {useEffect} from 'react';
import './style_exponent.css';
import InfiniteView from "../../components/InfiniteView";
import {useSelector} from "react-redux";
import {getExponentFilter, getExponents, getExponentSearch, getExponentsFetching, getExponentsHasMore} from "./reducer";
import {
    clearCountryFilter,
    clearSearch,
    clearSegmentFilter,
    EXPONENTS_PAGE_COUNT,
    fetchExponents,
    fetchSegments
} from "./action";


import { ReactComponent as GeoPointAsia } from '../../icons/geo-point-red.svg';
import { ReactComponent as GeoPointGras} from "../../icons/geo-point-green.svg";
import { ReactComponent as ArrowAsia } from '../../icons/arrow-icon-red.svg';
import { ReactComponent as ArrowGras } from "../../icons/arrow-icon-green.svg";

import {Flag} from "semantic-ui-react";
import BookmarkComponent from "../../components/Bookmark";
import {Base64} from "../../App";
import {setWindowScrollPosition} from "../../components/WindowDimensions";
import {getLanguage} from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import SadIcon from "../../icons/sad-icon.png";

import { ReactComponent as Arrow } from '../../icons/arrow-icon-red.svg';
import {getTypeExhibition} from "../Home/reducer";

export default function Exponents(props) {

    const { dispatch, filter, exponents: incomeExponents, routeAction, isPageReloaded, bookmarks, token, mixpanel } = props;

    const exponents = incomeExponents ?? useSelector((state) => getExponents(state.exponents));
    const isFetching = useSelector((state) => getExponentsFetching(state.exponents));
    const hasMore = useSelector((state) => getExponentsHasMore(state.exponents));
    const filterExponents = useSelector((state) => getExponentFilter(state.exponents));
    const searchExponents = useSelector((state) => getExponentSearch(state.exponents));

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));

    const expFilter = filter ??
        {
            countries: filterExponents.country ?? [],
            segments: filterExponents.segment ?? [],
        }

    useEffect(() => {
        if ( routeAction === 'PUSH' || isPageReloaded ) {
            readExponents(1)
             setWindowScrollPosition();
        }
        dispatch(clearSearch());
        if (mixpanel) {
            mixpanel.track('View. Exponents')
        }
        //dispatch(clearSegmentFilter())
        //dispatch(clearCountryFilter())
        //readExponents(1)
    }, []);

    useEffect(() => {
            readExponents(1);

    }, [filterExponents, searchExponents, typeExhibition]);

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const dataExhibition = {
        asia: {
            geoIcon: <GeoPointAsia />,
            arrowIcon: <ArrowAsia />,
        },
        gras: {
            geoIcon: <GeoPointGras />,
            arrowIcon: <ArrowGras />,
        }
    }

    const readExponents = (page)  => {
        const params = {
            page,
            per_page: EXPONENTS_PAGE_COUNT,
            order: 'asc',
            orderby: 'upper(name)',
            event: typeExhibition.toUpperCase() + 'EXPO 2025',
            lang: languageString,
        };


        if (bookmarks && bookmarks.length > 0) {
            params['bookmarks'] = bookmarks;
        }

        if (expFilter && (expFilter.countries.length > 0 || expFilter.segments.length > 0)) {
            params['filter'] = Base64.encode(JSON.stringify(expFilter));
        }

        if (searchExponents && searchExponents.length >= 3 ) {
            params['search'] = searchExponents
        }


        dispatch(fetchExponents(token, params));

        if (page === 1) dispatch(fetchSegments({
            hide_empty: true,
            order: 'asc',
            orderby: 'name',
            lang: languageString,
        }));
    }

    const loadMore = () => readExponents(Math.round(exponents.length / EXPONENTS_PAGE_COUNT) + 1);

    const ExponentCard = (props) => {
        const { exponent, navigate, typeExhibition, dataExhibition } = props;

        const segmentsExponent = exponent.segments ? exponent.segments.map(elem => elem.name).join(', ') : '';

        const archive = exponent.events && exponent.events.archive;
        let locationExponent = '';

        if (archive) {
            const asiaExpo2024Event = archive.find(event => event.event === "ASIAEXPO 2024");

            if (asiaExpo2024Event) {
                locationExponent = asiaExpo2024Event.stand_number;
            } else {
                locationExponent = archive.map(elem => elem.stand_number).join(", ");
            }
        }

        return (
            <>
                <div className="card-exponent">
                    <div className='bio-exponent'>

                        <img src={exponent.logo} className='img-exponent'/>
                        <div className='bio-exp'>
                            <div>
                                <div className='first-row-bio'>
                                    {dataExhibition[typeExhibition].geoIcon}
                                    <span className={`location-exponent-text ${typeExhibition}`}>{locationExponent}</span>
                                    <Flag name={exponent.country.toLowerCase()} className='flag-exponent'/>

                                </div>
                                <span
                                    className='exponent-name'>{languageString === "ru" ? exponent.name : exponent.name_en}
                            </span>
                            </div>
                        </div>
                        <div className="bookmark-exponent">
                            <BookmarkComponent
                                bookmark_using_for="exponents"
                                id={exponent.id}
                                {...props}
                            />
                        </div>
                    </div>
                    <span className='shortdesc-exponent'>{languageString === "ru" ? exponent.excerpt : exponent.excerpt_en}</span>
                    <div className='more-container' onClick={() => navigate(`/exponents/exponents-card/${exponent.id}`)}>
                        <span className={`more-text ${typeExhibition}`}>{t("details")}</span>
                        {dataExhibition[typeExhibition].arrowIcon}
                    </div>
                </div>
            </>
        )
    }

    const ExponentsList = (props) => {
        const {exponents, title} = props;
        //console.log(props)
        return (
            !navigator.onLine ?
                <div className='view-bookmarks'>
                    <img src={SadIcon} alt={""}/>
                    <span className='text-bookmark'>{t("noExponents")}</span>
                </div>
                : <div className="container exponents filter-opened">
                    {exponents ? exponents.map((element) => (
                        <ExponentCard
                            key={element.id}
                            exponent={element}
                            showLoader
                            {...props}
                        />
                    )) : ''}
                </div>
        );
    }

    return (
        <>
            <InfiniteView
                dataLength={exponents.length}
                nextFetch={loadMore}
                hasMore={hasMore}
                dataList={(
                    <ExponentsList
                        exponents={exponents}
                        typeExhibition={typeExhibition}
                        dataExhibition={dataExhibition}
                        {...props}
                    />
                )}
                hideEndMessage={true}
                mustAuth={false}
                isLoading={isFetching}
                loaderText={t("loadExponents") + "..."}
                zeroText={ !isFetching ? (
                    <div className='view-bookmarks'>
                        <img src={SadIcon} alt={""}/>
                        <span className='text-bookmark'>{t("noExponents")}</span>
                    </div>
                ) : ""}
            />
        </>
    );
};



